export const USER_KEY = "user";
export const BEARER_KEY = "Bearer";

export const ROLES = {
  Admin: "APP_ADMIN",
  User: "APP_USER",
  CS: "APP_CS",
  Sales: "APP_SALES",
  KPT: "APP_KPT",
};
window.ROLES = ROLES
export function storeUser(user, bearer) {
  const localUser = JSON.parse(JSON.stringify(user));
  if (!localUser.firstName) {
    localUser.firstName = "";
  }
  if (!localUser.lastName) {
    localUser.lastName = "";
  }

  localStorage.setItem(BEARER_KEY, bearer);
  localStorage.setItem(USER_KEY, JSON.stringify(localUser));
}

export function removeUser() {
  localStorage.removeItem(BEARER_KEY);
  localStorage.removeItem(USER_KEY);
}

export function updateUserData(userData) {
  const existingUser = getUser();
  const updatedUser = { ...existingUser, ...userData };
  localStorage.setItem(USER_KEY, JSON.stringify(updatedUser));
}

export function getBearer() {
  return localStorage.getItem(BEARER_KEY);
}

export function setName(firstName, lastName) {
  const user = getUser();
  user.firstName = firstName;
  user.lastName = lastName;
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function getUser() {
  const userJson = localStorage.getItem(USER_KEY);
  return userJson ? JSON.parse(userJson) : null;
}

export function getUserId() {
  const userJson = localStorage.getItem(USER_KEY);
  if (!userJson) {
    return -1;
  }
  const user = JSON.parse(userJson);
  return user.id;
}

export function getLanguage() {
  if (!localStorage) {
    return null;
  }
  const user = getUser();
  if (!user || !user.language) {
    return null;
  }

  return user.language.toLowerCase();
}

export function hasRole(roles = []) {
  const user = getUser();

  if (!user) {
    return false;
  }

  return roles.indexOf(user.appRole) > -1;
}
